// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t5Dz","left":"styles_left__3t6gK"};